// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import { Icon, IconButton } from '@material-ui/core';

import { isDevFlagEnabled } from 'common/components/DevFlag';
import { Tr, Td } from './CustomerTable';
import RadioCustomer from '../types/RadioCustomer';

const Wrapper = styled(Tr)`
  height: 60px;

  :hover {
    background-color: ${({ theme }) => theme.colors.primaryBackground};
  }
`;

const Information = styled(Td)`
  align-self: center;
  text-align: center;
`;

type Props = {
  customer: RadioCustomer,
  onDeleteCustomer: (customer: RadioCustomer) => void,
  onEditCustomer: (customer: RadioCustomer) => void,

  t: any,
};

class CustomerEntry extends React.PureComponent<Props> {
  onDeleteCustomerConfirmed = (): void => {
    const { customer } = this.props;
    this.props.onDeleteCustomer(customer);
  };

  onEditCustomer = () => {
    const { onEditCustomer, customer } = this.props;
    onEditCustomer(customer);
  };

  render() {
    const { customer, onEditCustomer, t } = this.props;

    const contact = `${customer.getContactFullName()} (${customer.getContactEmail()})`;

    if (isDevFlagEnabled('EDIT_RADIOCUSTOMER')) {
      return (
        <Wrapper>
          <Information>{customer.getAdvertiserName()}</Information>
          <Information>{customer.getContactFullName()}</Information>
          <Information>{customer.getContactEmail()}</Information>
          <Information>{customer.hasAccessToFollo && <Icon>done</Icon>}</Information>
          <Information>
            <IconButton color="primary" onClick={this.onEditCustomer}>
              <Icon>create</Icon>
            </IconButton>
            <IconButton color="primary" onClick={this.onDeleteCustomerConfirmed}>
              <Icon>delete</Icon>
            </IconButton>
          </Information>
        </Wrapper>
      );
    }
    return (
      <Wrapper>
        <Information>
          <i className="material-icons">{customer.hasAcceptedInvitation() ? 'check' : 'email'} </i>
        </Information>
        <Information>{customer.getAdvertiserName()}</Information>
        <Information>{contact}</Information>
        <Information>
          <RaisedButton primary onClick={() => onEditCustomer(customer)} label={t('manage')} />
        </Information>
      </Wrapper>
    );
  }

}

export default translate('customers')(CustomerEntry);



// WEBPACK FOOTER //
// ./src/statsradio/modules/customers/components/CustomerEntry.js